import { useSelector } from "react-redux";
import { useMemo } from "react";
import { LayerDefinitionDc } from "@evergis/api";

import { getCurrentLayer } from "../../ducks/location/selectors";
import { usePostgresLayer } from "./usePostgresLayer";

export const useCurrentLayer = () => {
  const layerName = useSelector(getCurrentLayer);
  const { postgresLayer } = usePostgresLayer(layerName, { waitInput: true });

  return postgresLayer;
};

export const useCurrentLayerAlias = (): string => {
  const currentLayer = useCurrentLayer();

  return useMemo(() => (currentLayer && currentLayer.alias) || "", [currentLayer]);
};

export const useCurrentLayerDefinition = (): LayerDefinitionDc | undefined => {
  const currentLayer = useCurrentLayer();

  return useMemo(() => currentLayer.layerDefinition, [currentLayer]);
};

export const useCurrentLayerName = (): string => {
  const currentLayer = useCurrentLayer();

  return useMemo(() => (currentLayer && currentLayer.name) || "", [currentLayer]);
};

export const useCurrentLayerTableName = (): string => {
  const currentLayer = useCurrentLayer();

  return useMemo(() => currentLayer && currentLayer.tableName, [currentLayer]);
};
